export enum BrokerListActionTypes {
  Init = '[BrokersList Page] Init',
  FilterChanged = '[BrokersList Page] Filter Changed',
  ListViewTypeChanged = '[BrokersList Page] List View Type Changed',
  ViewMoreClicked = '[BrokersList Page] View More Clicked',
}

export enum BrokerDetailsActionTypes {
  BrokerDetailsInit = '[BrokerDetails Page] Init',

  BrokerDeleted = '[BrokerDetails Page] Broker Deleted',
  BrokerEnabled = '[BrokerDetails Page] Broker Enabled',

  ClientsListViewChanged = '[BrokerDetails Page] Clients List View Changed',
  ClientsFilterChanged = '[BrokerDetails Page] Clients Filter Changed',
  ViewMoreClients = '[BrokerDetails Page] View More Clients',

  Destroyed = '[BrokerDetails Page] Destroyed',
}

export enum MyBrokersActionTypes {
  Init = '[MyBrokers Page] Init',
  BrokerSelected = '[MyBrokers Page] Broker Selected',
  BrokerDeselected = '[MyBrokers Page] Broker Deselected',
  Destroyed = '[MyBrokers Page] Destroyed',
}

export enum BrokerCreateUpdateActionTypes {
  InitCreate = '[BrokerCreateUpdate Page] Init Create',
  InitUpdate = '[BrokerCreateUpdate Page] Init Update',

  Added = '[BrokerCreateUpdate Page] Added',
  Updated = '[BrokerCreateUpdate Page] Updated',

  Destroyed = '[BrokerCreateUpdate Page] Destroyed',
}
